import { ReactNode, MouseEvent } from "react";
import { cn } from "lib/utils";

export interface BottomSectionButtonProps {
    active: boolean;
    children: ReactNode;
    onClick: (e: MouseEvent) => void;
    className?: string;
}

export const BottomSectionButton = ({ active, children, onClick, className }: BottomSectionButtonProps) => {
    return (
        <div
            className={cn(
                `cursor-pointer ${
                    active ? "bg-irBlue-200 dark:bg-darkPrimary-100" : "bg-irGray-400 dark:bg-darkSurface-600"
                } text-white text-center flex items-center justify-center gap-4 capitalize font-semibold px-4 py-4 rounded-xl`,
                className,
            )}
            onClick={onClick}
        >
            {children}
        </div>
    );
};
